export interface FaqInfoProps {
  question: string;
  answer: string;
  analytics: string;
}

export const faqInfo = (): FaqInfoProps[] => [
  {
    question: 'Que couvre l’assurance habitation pour propriétaires ?',
    answer:
      "Notre assurance habitation se décompose en trois parties : la couverture de la structure de la maison que vous possédez, la couverture des objets que vous possédez, et la couverture de votre responsabilité civile si vous causez accidentellement des dommages ou des blessures à quelqu'un d'autre.",
    analytics: 'ho_what_does_the_policy_cover',
  },
  {
    question: 'Pour quels types de sinistres suis-je couvert(e) ?',
    answer:
      'Nous couvrons les dommages causés à votre habitation et à vos biens par le feu, la fumée, les explosions, les surtensions, les événements climatiques, et les dégâts des eaux. Pour plus de détails sur ce qui est couvert, vous pouvez créer un devis gratuit ou consulter notre police.',
    analytics: 'unfortunate',
  },
  {
    question: 'Combien coûte une assurance habitation pour propriétaires ?',
    answer:
      "L'assurance habitation pour propriétaires chez Lemonade commence à 10 € /mois, mais varie en fonction de facteurs tels que l'âge de votre logement, le coût de la reconstruction, les matériaux de construction, ainsi que les garanties que vous choisissez.",
    analytics: 'insurance_cost',
  },
  {
    question: "Qu'est-ce que le réseau de réparation ?",
    answer:
      "Si, après un sinistre un élément de votre logement a besoin d'être réparé, Lemonade vous donnera accès à un réseau de réparation comprenant un large éventail de prestataires en France qui peuvent vous aider à réparer certains éléments de votre logement.",
    analytics: 'repair_network',
  },
  {
    question: 'Comment recevoir mon attestation d’assurance habitation ?',
    answer:
      'Vous recevez votre attestation d’assurance habitation Lemonade par email dès votre souscription, mais en cas de doute et pour toujours l’avoir dans votre poche, vous pouvez également la télécharger à nouveau depuis l’app !',
    analytics: 'insurance_certificate',
  },
  {
    question: 'Quelles garanties supplémentaires puis-je souscrire ?',
    answer:
      'Parmi les garanties supplémentaires que vous pouvez ajouter, on retrouve la garantie contre le cambriolage et le vandalisme, la garantie complète contre le vol, la garantie bris de glace, l’assurance scolaire, ou encore la protection juridique.',
    analytics: 'additional_coverages',
  },
  {
    question: 'Mes dépendances sont-elles couvertes ?',
    answer:
      'Lors de votre devis, notre chatbot Maya vous demandera toutes les informations dont nous avons besoin concernant votre habitation. En règle générale, si vous déclarez votre garage, votre abri de jardin, votre débarras, votre piscine, votre cheminée, votre panneau solaire et votre véranda lors du devis, c’est couvert !',
    analytics: 'outbuildings_covered',
  },
  {
    question: 'Comment déclarer un sinistre ?',
    answer: `Facile ! Il suffit d'ouvrir l'app Lemonade et d'appuyer sur le bouton Sinistres. Nous vous guiderons dans le reste de la procédure. Si vous avez besoin d’aide, n'hésitez pas à nous envoyer un email à <a href="mailto:contact@lemonade.com">contact@lemonade.com</a>.`,
    analytics: 'file_claim',
  },
  {
    question: 'Comment vous contacter ?',
    answer: `Vous pouvez contacter notre équipe à tout moment via notre app et notre site web, ou n’hésitez pas à envoyer un email à  <a href="mailto:contact@lemonade.com">contact@lemonade.com</a>. Nos services sont ouverts du lundi au vendredi de 9h à 18h. En cas d’urgence uniquement et si vous souhaitez contacter nos services d’assistance, appelez nos partenaires d’assistance au  : <a href="tel:+33801840506">+33 801 840506</a>.`,
    analytics: 'contact_us',
  },
];
